export default {
  feedbackReports: {
    tab: 'Geri bildirim',
    title: 'Kurs geri bildirimleri',
    subtitle: 'Seçilen kurslar ve tarihler için gönderilen geri bildirimleri inceleyin.',
    allCourses: 'Tüm kurslar',
    from: 'Başlangıç (UTC)',
    to: 'Bitiş (UTC)',
    apply: 'Filtreleri uygula',
    dateError: 'Başlangıç tarihi bitiş tarihinden sonra olamaz.',
    exportHint: 'Filtrelere uyan tüm yanıtlar, her soru ayrı satırda olacak şekilde dışa aktarılır. Tek seferde en fazla 10.000 geri bildirim aktarılabilir.',
    exportLimit: 'Bu filtrelere uyan 10.000’den fazla geri bildirim var. Dışa aktarmak için bir kurs veya daha kısa bir tarih aralığı seçin.',
    empty: 'Geri bildirim bulunamadı',
    emptyHint: 'Bu filtrelere uyan henüz gönderilmiş bir geri bildirim yok.',
    responseCount: 'Geri bildirim sayısı',
    average: 'Ortalama faydalılık puanı',
    ratedCount: '{count} değerlendirmeye göre',
    version: 'Anket sürümü {version} · {count} yanıt',
    answered: '{total} kişiden {count} kişi yanıtladı',
    multipleHint: 'Birden fazla seçenek işaretlenebilir. Yüzdeler bu soruyu yanıtlayan kişi sayısına göre hesaplanır.',
    responses: 'Bireysel yanıtlar',
    submitted: 'Gönderilme zamanı (UTC)',
    helpfulness: 'Faydalılık',
    answers: 'Yanıtlar',
    view: 'Yanıtları gör',
    previous: 'Önceki',
    next: 'Sonraki',
    page: 'Sayfa {page} / {total}',
    responseFrom: '{name} kullanıcısının geri bildirimi',
    responseVersion: 'Kurs sürümü {course} · Anket sürümü {questionnaire}',
    unanswered: 'Yanıtlanmadı',
    close: 'Yanıtları kapat',
  },
  courseFeedback: {
    tab: 'Kurs geri bildirimi',
    navigationLocked: 'Lütfen önce geri bildirim formunu doldurup gönderin.',
    submitCertificate: 'Geri bildirimi gönder ve sertifikayı görüntüle',
    submitCourses: 'Geri bildirimi gönder ve kurslara dön',
    submitJourney: 'Geri bildirimi gönder ve yolculuğa devam et',
    backToJourney: 'Yolculuğa dön',
    readOnly: 'Bu kurs için daha önce gönderdiğiniz yanıtlar.',
    notAnswered: 'Yanıtlanmadı',
    eyebrow: 'Kurs tamamlandı',
    completeTitle: 'Tebrikler! Kursu tamamladınız.',
    title: 'Kursunuz nasıldı?',
    intro: 'Geri bildiriminiz kurslarımızı geliştirmemize yardımcı olur. Birkaç tıklama yeterli.',
    required: 'Zorunlu',
    optional: 'İsteğe bağlı',
    multiple: 'Birden fazla seçenek işaretleyebilirsiniz.',
    thanks: 'Geri bildiriminiz için teşekkürler!',
    saved: 'Bu kurs için yanıtlarınız kaydedildi.',
    loading: 'Geri bildirim yükleniyor…',
    loadError: 'Geri bildirim formu yüklenemedi. Kursunuz tamamlandı. Lütfen yeniden deneyin.',
    retry: 'Yeniden dene',
    saveError: 'Geri bildiriminiz kaydedilemedi. Seçimleriniz korunuyor. Lütfen yeniden gönderin.',
    submit: 'Geri bildirim gönder',
    completionSaved: 'Kursu tamamladığınız zaten kaydedildi.',
    certificate: 'Sertifikayı görüntüle',
    backToCourses: 'Kurslara dön',
  },
  common: {
    appName: 'Reybex Academy',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    saved: 'Kaydedildi',
    cancel: 'İptal',
    close: 'Kapat',
    delete: 'Sil',
    remove: 'Çıkar',
    edit: 'Düzenle',
    create: 'Oluştur',
    add: 'Ekle',
    back: 'Geri',
    next: 'İleri',
    previous: 'Önceki',
    search: 'Ara',
    searchPlaceholder: 'Ara…',
    filter: 'Filtrele',
    clear: 'Temizle',
    clearFilters: 'Filtreleri temizle',
    all: 'Tümü',
    none: 'Yok',
    yes: 'Evet',
    no: 'Hayır',
    optional: 'İsteğe bağlı',
    required: 'Zorunlu',
    loading: 'Yükleniyor…',
    retry: 'Tekrar dene',
    confirm: 'Onayla',
    actions: 'İşlemler',
    status: 'Durum',
    title: 'Başlık',
    description: 'Açıklama',
    duration: 'Süre',
    points: 'puan',
    pointsLabel: 'Puan',
    progress: 'İlerleme',
    minutes: '{count} dk',
    hours: '{count} sa',
    of: '/',
    showing: '{total} kayıttan {from}–{to} gösteriliyor',
    page: 'Sayfa {page}',
    unknown: 'Bilinmiyor',
    never: 'Hiç',
    today: 'Bugün',
    dueOn: 'Son tarih {date}',
    overdue: 'Gecikmiş',
    notSet: 'Belirtilmedi',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    copyLink: 'Herkese açık bağlantıyı kopyala',
    linkCopied: 'Bağlantı kopyalandı.',
    download: 'İndir',
    preview: 'Önizle',
    publish: 'Yayınla',
    unpublish: 'Yayından kaldır',
    archive: 'Arşivle',
    restore: 'Geri yükle',
    signOut: 'Çıkış yap',
    profile: 'Profil',
    language: 'Dil',
    theme: 'Tema',
    learner: 'Öğrenci',
    instructor: 'Eğitmen',
    admin: 'Yönetici',
  },

  nav: {
    dashboard: 'Panel',
    courses: 'Kurslar',
    journeys: 'Öğrenme Yolculukları',
    certificates: 'Sertifikalar',
    profile: 'Profil',
    adminArea: 'Yönetim',
    adminDashboard: 'Kurslar',
    adminCourses: 'Kurslar',
    adminJourneys: 'Öğrenme Yolculukları',
    adminUsers: 'Kullanıcılar',
    adminReports: 'Raporlar',
    adminSettings: 'Ayarlar',
    backToLearning: 'Panele dön',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
    skipToContent: 'İçeriğe geç',
    signInRequired: 'Giriş gerekli',
  },

  auth: {
    loginTitle: 'Giriş yap',
    loginSubtitle: 'Öğrenmeye devam et',
    reybexLoginSubtitle: 'Reybex kullanıcı adın ve şifrenle giriş yap',
    lmsAccount: 'LMS hesabı',
    reybexAccount: 'Reybex hesabı',
    username: 'Kullanıcı adı',
    signInWithReybex: 'Reybex ile giriş yap',
    registerTitle: 'Hesabını oluştur',
    registerSubtitle: 'Birkaç dakika içinde öğrenmeye başla',
    forgotTitle: 'Şifreni sıfırla',
    forgotSubtitle: 'Sıfırlama bağlantısını e-posta ile göndereceğiz',
    resetTitle: 'Yeni bir şifre belirle',
    email: 'E-posta',
    password: 'Şifre',
    confirmPassword: 'Şifreyi Doğrula',
    fullName: 'Ad Soyad',
    signIn: 'Giriş yap',
    signUp: 'Hesap oluştur',
    sendResetLink: 'Sıfırlama bağlantısı gönder',
    updatePassword: 'Şifreyi Güncelle',
    noAccount: 'Hesabın yok mu?',
    haveAccount: 'Zaten hesabın var mı?',
    forgotPassword: 'Şifreni mi unuttun?',
    backToLogin: 'Girişe dön',
    landingPage: 'Açılış Sayfası',
    continueAsGuest: 'Giriş yapmadan devam et',
    resetLinkSent: 'Sıfırlama bağlantısı için gelen kutunu kontrol et.',
    passwordUpdated: 'Şifren güncellendi.',
    registrationComplete: 'Hesabın oluşturuldu. Devam etmek için giriş yap.',
    signedOut: 'Çıkış yaptın.',
    accountDeactivated:
      'Bu hesap devre dışı bırakıldı. Erişimi geri açmak için bir yöneticiyle görüş.',
    sessionExpired: 'Oturumun sona erdi. Lütfen yeniden giriş yap.',
    showPassword: 'Şifreyi göster',
    hidePassword: 'Şifreyi gizle',
    profile: 'Profiliniz',
    profileSubtitle: 'Bilgileriniz ve platformun sizin için nasıl davrandığı.',
    reybexDetails: {
      partnerAccount: 'Partner hesabı',
      title: 'Reybex Hesap Bilgileri',
      tenantId: 'Tenant ID',
      username: 'Kullanıcı Adı',
      email: 'E-posta',
      phone: 'Telefon',
      mobile: 'Cep Telefonu',
      language: 'Dil',
      timezone: 'Saat Dilimi',
      position: 'Pozisyon',
      signInAgain: 'Bilgilerinizi yüklemek için çıkış yapıp Reybex hesabınızla tekrar giriş yapın.',
    },
    accountDetails: 'Hesap Bilgileri',
    academyAccountDetails: 'Academy Hesap Bilgileri',
    timezone: 'Saat Dilimi',
    changePassword: 'Şifre Değiştir',
    newPassword: 'Yeni Şifre',
    passwordHint: 'En az 8 karakter.',
    passwordManagedByReybex: 'Bu hesabın şifresi Reybex üzerinden yönetilir.',
    memberSince: '{date} tarihinden beri üye',
    profileSaved: 'Profiliniz kaydedildi.',
  },

  dashboard: {
    greeting: 'Merhaba, {name}',
    learnerSubtitle: 'Kaldığın yer burası.',
    adminTitle: 'Kurs kataloğu',
    adminSubtitle: 'Kurs oluştur, ders ve sınav ekle, ardından yayınla.',
    defineCourses: 'Kursların',
    defineCoursesHint: 'İçerik tanımlamaya başlamak için bir kurs oluştur.',
    newCourseHint: 'Başlık yeterli. Gerisini düzenleyicide doldurursun.',
    noCoursesYet: 'Henüz kurs yok',
    claimAdminBanner: 'Bu kurulumda henüz yönetici yok. Kurs tanımlamak için yönetici rolünü al.',
    claimAdminAction: 'Yönetici kurulumunu aç',
    totalPoints: 'Toplam puan',
    inProgress: 'Devam eden',
    completed: 'Tamamlanan',
    notStarted: 'Başlanmayan',
    certificates: 'Sertifikalar',
    averageProgress: 'Ortalama ilerleme',
    continueLearning: 'Öğrenmeye devam et',
    recentCourses: 'Son görüntülenenler',
    assignedCourses: 'Sana atananlar',
    recommended: 'Senin için öneriler',
    journeyProgress: 'Öğrenme Yolculukların',
    upcomingDeadlines: 'Yaklaşan son tarihler',
    achievements: 'Başarımlar',
    noDeadlines: 'Yaklaşan bir son tarih yok.',
    noAchievements: 'İlk başarımını kazanmak için bir kursu tamamla.',
    achievementsInvite: 'Bir kurs bitir, sertifika kazan veya bir öğrenme yolculuğunu tamamla.',
    totalUsers: 'Kullanıcılar',
    activeLearners: 'Aktif öğrenciler (30 gün)',
    totalCourses: 'Kurslar',
    completionRate: 'Tamamlama oranı',
    quizPerformance: 'Ortalama sınav puanı',
    quizPassRate: 'Sınav geçme oranı',
    popularCourses: 'En popüler kurslar',
    recentRegistrations: 'Son kayıtlar',
    recentCompletions: 'Son tamamlamalar',
    overdueAssignments: 'Gecikmiş atamalar',
    certificatesIssued: 'Verilen sertifikalar',
    enrollments: 'Kayıtlar',
  },

  onboarding: {
    suggested: 'Önerilen kurslar',
    personalize: 'Kişiselleştir',
    emptyHint: 'Sana uygun kursları görmek için çalışma alanını seç.',
    welcomeTitle: 'Reybex Academy’ye hoş geldin',
    welcomeBody: 'Öğrenmeni bir dakikadan kısa sürede kişiselleştirelim.',
    start: 'Kuruluma başla',
    skip: 'Şimdilik geç',
    back: 'Geri',
    next: 'İleri',
    finish: 'Bitir',
    stepOf: 'Soru {current} / {total}',
    roleTitle: 'İşin hangisine daha yakın?',
    roleMulti: 'Birden fazla seçebilirsin.',
    levelTitle: 'Reybex Academy deneyimin ne düzeyde?',
    focusTitle: 'Önce neye odaklanmak istersin?',
    focusOptional: 'Bu adımı geçebilirsin.',
    doneTitle: 'Hazırsın',
    doneBody: 'Önerilen kurslar seçtiğin alanlara göre gelir.',
    role: {
      sales: 'Satış',
      salesBody: 'Teklif, müşteri ve satış süreçleri.',
      warehouse: 'Depo',
      warehouseBody: 'Stok, toplama ve sevkiyat.',
      purchasing: 'Satınalma',
      purchasingBody: 'Tedarikçi ve satın alma.',
      production: 'Üretim',
      productionBody: 'Üretim ve atölye akışları.',
      finance: 'Finans',
      financeBody: 'Fatura, ödeme ve raporlama.',
      ecommerce: 'E-ticaret',
      ecommerceBody: 'Mağaza, sipariş ve online satış.',
      developer: 'Teknik',
      developerBody: 'Kurulum, API ve genişletme.',
      partner: 'Partner',
      partnerBody: 'Dış partner eğitimi.',
    },
    level: {
      new: 'Reybex Academy’ye yeni',
      basic: 'Temel bilgi',
      intermediate: 'Orta',
      advanced: 'İleri',
    },
    focus: {
      quick: 'Hızlı başlangıç',
      role: 'Role göre eğitim',
      certificates: 'Sertifikalar',
      advanced: 'İleri süreçler',
    },
    none: 'Bu alanda henüz kurs yok.',
  },

  courses: {
    title: 'Kurslar',
    subtitle: 'Mevcut kurslara göz at ve kaldığın yerden devam et.',
    myCourses: 'Kurslarım',
    catalog: 'Katalog',
    allCourses: 'Tüm kurslar',
    enroll: 'Kaydol',
    signInToEnroll: 'Kaydolmak için giriş yap',
    enrolling: 'Kaydediliyor…',
    enrolled: 'Kayıtlı',
    start: 'Kursa başla',
    continue: 'Devam et',
    review: 'Gözden geçir',
    retakeQuiz: 'Sınavı tekrar al',
    takeQuiz: 'Sınava gir',
    viewCourse: 'Görüntüle',
    lessons: '{count} ders',
    lessonsLabel: 'Dersler',
    lessonsCompleted: '{total} dersten {done} tamamlandı',
    category: 'Kategori',
    difficulty: 'Seviye',
    instructor: 'Eğitmen',
    language: 'Dil',
    objectives: 'Neler öğreneceksin',
    prerequisites: 'Ön Koşullar',
    courseContent: 'Kurs içeriği',
    aboutCourse: 'Bu kurs hakkında',
    estimatedDuration: 'Tahmini Süre',
    certificateAvailable: 'Tamamlayınca sertifika',
    pointsOnCompletion: 'Tamamlayınca {points} puan',
    quizRequired: 'Bu kursu tamamlamak için final sınavını geçmen gerekir.',
    difficultyBeginner: 'Başlangıç',
    difficultyIntermediate: 'Orta',
    difficultyAdvanced: 'İleri',
    visibilityPrivate: 'Özel',
    visibilityPublic: 'Herkese açık',
    statusDraft: 'Taslak',
    statusPublished: 'Yayında',
    statusArchived: 'Arşivlendi',
    state: {
      not_started: 'Başlanmadı',
      in_progress: 'Devam ediyor',
      quiz_pending: 'Sınav bekleniyor',
      quiz_failed: 'Sınav geçilemedi',
      completed: 'Tamamlandı',
    },
    stateHint: {
      not_started: 'Bu kursa henüz başlamadın.',
      in_progress: 'Devam et — bazı zorunlu dersler hâlâ açık.',
      quiz_pending: 'Tüm dersler tamam. Kursu bitirmek için sınavı geç.',
      quiz_failed: 'Geçme puanına ulaşamadın. Dersleri gözden geçir ve tekrar dene.',
      completed: 'Bu kursu tamamladın.',
    },
    empty: 'Gösterilecek kurs yok.',
    emptyEnrolled: 'Henüz hiçbir kursa kayıtlı değilsin.',
    emptyCatalog: 'Henüz yayınlanmış içerik yok. Daha sonra tekrar bak.',
    archivedNotice: 'Bu kurs arşivlendi. Gözden geçirebilirsin ama yeniden başlatılamaz.',
    unpublishedNotice:
      'Bu kurs artık yayında değil. Önceden kayıtlı olduğun için erişimin sürüyor.',
  },

  player: {
    courseContent: 'Kurs içeriği',
    lesson: 'Ders',
    quiz: 'Sınav',
    markComplete: 'Tamamlandı olarak işaretle',
    markingComplete: 'Kaydediliyor…',
    completed: 'Tamamlandı',
    nextLesson: 'Sonraki ders',
    previousLesson: 'Önceki ders',
    resources: 'İndirilenler',
    transcript: 'Transkript',
    noResources: 'Bu ders için indirilecek dosya yok.',
    progressLabel: '%{percent} tamamlandı',
    lessonCompletedToast: 'Ders tamamlandı',
    allLessonsDone: 'Tüm dersler tamamlandı.',
    quizPendingBanner: 'Zorunlu derslerin tamamını bitirdin. Son adım sınav.',
    quizFailedBanner: 'Son denemen geçemedi. Materyali gözden geçir ve tekrar dene.',
    courseCompleteBanner: 'Kurs tamamlandı. Puanın ve sertifikan hazır.',
    courseCompleteShort: 'Kurs tamamlandı.',
    quizLockedByLessons: 'Sınavın açılması için tüm zorunlu dersleri tamamla.',
    resumeNotice: 'Kaldığın yerden devam ediliyor.',
    videoUnavailable: 'Bu video şu anda oynatılamıyor.',
    videoUnavailableHint:
      'Dosya yüklenemedi. Tekrar deneyebilir ya da başka bir dersle devam edebilirsin.',
    videoMissingSource: 'Bu derse henüz bir video dosyası eklenmemiş.',
    reportProblem: 'Sorun bildir',
    problemReported: 'Teşekkürler — bir yönetici bilgilendirildi.',
    offline: 'Bağlantın yok. İlerlemen bağlantı geri geldiğinde kaydedilecek.',
    backToCourse: 'Kurs özeti',
    requiredLesson: 'Zorunlu',
    optionalLesson: 'İsteğe bağlı',
    journeyContext: '{journey} yolculuğunun bir parçası',
    nextInJourney: 'Bu yolculukta sırada',
    exitPlayer: 'Oynatıcıdan çık',
    lessonList: 'Dersler',
    pauseNudge: 'Devam et — bu dersi tamamlamak için {percent}% kaldı.',
    watchRing: '{watched}% izlendi. {threshold}% olunca tamamlanır.',
    requirementsChanged: 'Bu kurs güncellendi ve artık ek zorunlu dersler içeriyor.',
  },

  quiz: {
    title: 'Sınav',
    start: 'Sınava başla',
    starting: 'Başlatılıyor…',
    resume: 'Sınava devam et',
    submit: 'Cevapları gönder',
    submitting: 'Gönderiliyor…',
    question: 'Soru {current}/{total}',
    passingScore: 'Geçme puanı: %{score}',
    timeLimit: 'Süre sınırı: {minutes} dk',
    noTimeLimit: 'Süre sınırı yok',
    attemptsLeft: '{count} deneme kaldı',
    attemptsUnlimited: 'Sınırsız deneme',
    attemptNumber: '{number}. deneme',
    timeRemaining: 'Kalan süre',
    timeUp: 'Süre doldu. Cevapların gönderildi.',
    selectOne: 'Bir cevap seç',
    selectMultiple: 'Uygun olanların tümünü seç',
    trueLabel: 'Doğru',
    falseLabel: 'Yanlış',
    unanswered: '{count} cevaplanmadı',
    confirmSubmitTitle: 'Cevaplarını gönder?',
    confirmSubmitBody: 'Cevaplanmamış {count} soru var. Şimdi gönderirsen bunlar yanlış sayılır.',
    confirmSubmitAll: 'Yine de gönder',
    resultPassed: 'Geçtin',
    resultFailed: 'Geçemedi',
    certificateUnlocked: 'Kurs sertifikasını kazandın.',
    redirectingToCertificate: 'Sertifika sayfasına yönlendiriliyorsun…',
    yourScore: 'Puanın',
    scoreOf: '%{score} (geçme puanı %{passing})',
    reviewAnswers: 'Cevaplarını gözden geçir',
    continueToFeedback: 'Kurs geri bildirimine geç',
    backToResults: 'Sınav sonuçlarına dön',
    reviewLoadError:
      'Sonucunuz kaydedildi ancak yanıt incelemesi yüklenemedi. Lütfen yeniden deneyin.',
    correct: 'Doğru',
    incorrect: 'Yanlış',
    explanation: 'Açıklama',
    attemptHistory: 'Önceki denemeler',
    noAttempts: 'Henüz deneme yok.',
    maxAttemptsReached:
      '{count} denemenin tamamını kullandın. Yeni bir deneme gerekiyorsa bir yöneticiyle görüş.',
    retake: 'Tekrar dene',
    backToCourse: 'Kursa dön',
    expiredNotice: 'Bu deneme süre sınırından sonra gönderildi ve olduğu gibi puanlandı.',
    invalidatedNotice:
      'Denemen açıkken sınav değişti, bu yüzden iptal edildi. Ücretsiz olarak yeniden başlayabilirsin.',
    draftRestored: 'Daha önce seçtiğin cevaplar geri yüklendi.',
    submitFailedRetrying: 'Gönderim başarısız. Yeniden denenecek…',
    submitFailed: 'Cevaplarını gönderemedik. Bağlantını kontrol et ve tekrar dene.',
  },

  journeys: {
    title: 'Öğrenme Yolculukları',
    subtitle: 'Birden fazla kursu birleştiren yapılandırılmış yolculuklar.',
    start: 'Yolculuğa başla',
    signUpToStart: 'Başlamak için hesap oluştur',
    continue: 'Yolculuğa devam et',
    leave: 'Yolculuktan ayrıl',
    leaveConfirmTitle: 'Bu yolculuktan ayrılmak istiyor musun?',
    leaveConfirmBody:
      'Kurs ilerlemen korunur. Daha sonra yeniden katılıp kaldığın yerden devam edebilirsin.',
    rejoin: 'Yolculuğa yeniden katıl',
    courses: 'Bu yolculuktaki kurslar',
    courseCount: '{count} kurs',
    modeSequential: 'Sıralı',
    modeFlexible: 'Esnek',
    modeSequentialHint: 'Zorunlu kurslar sırayla tamamlanmalıdır.',
    modeFlexibleHint: 'Zorunlu kurslar herhangi bir sırayla tamamlanabilir.',
    locked: 'Kilitli',
    lockedHint: 'Bunun açılması için önceki zorunlu kursu tamamla.',
    completedCourses: 'Tamamlanan',
    remainingCourses: 'Kalan',
    state: {
      not_started: 'Başlanmadı',
      in_progress: 'Devam ediyor',
      completed: 'Tamamlandı',
      abandoned: 'Ayrıldı',
    },
    empty: 'Henüz yayınlanmış öğrenme yolculuğu yok.',
    completedBanner: 'Yolculuk tamamlandı. Sertifikan hazır.',
    objectives: 'Bu yolculuk neleri kapsıyor',
  },

  certificates: {
    title: 'Sertifikalar',
    subtitle: 'Kazandığın her şey.',
    certificateNumber: 'Sertifika numarası',
    issuedOn: 'Veriliş tarihi',
    expiresOn: 'Geçerlilik sonu',
    noExpiry: 'Süresiz',
    learner: 'Verilen kişi',
    course: 'Kurs',
    journey: 'Öğrenme Yolculuğu',
    downloadPdf: 'PDF indir',
    generating: 'Hazırlanıyor…',
    verify: 'Doğrula',
    verifyTitle: 'Sertifika doğrulama',
    verifySubtitle: 'Bir sertifikanın gerçek olup olmadığını kontrol et.',
    verifyLinkCopied: 'Doğrulama bağlantısı kopyalandı.',
    copyVerifyLink: 'Doğrulama bağlantısını kopyala',
    empty: 'Henüz sertifikan yok. Bir kursu tamamlayarak kazanabilirsin.',
    justEarned: 'Tebrikler — sertifikan hazır.',
    statusActive: 'Geçerli',
    statusRevoked: 'İptal edildi',
    statusExpired: 'Süresi doldu',
    notFound: 'Bu doğrulama bağlantısıyla eşleşen bir sertifika yok.',
    verifiedValid: 'Bu sertifika geçerli.',
    verifiedRevoked: 'Bu sertifika {date} tarihinde iptal edildi.',
    verifiedExpired: 'Bu sertifikanın geçerliliği {date} tarihinde doldu.',
    issuedBy: 'Veren',
    revoke: 'İptal et',
    revokeTitle: 'Bu sertifikayı iptal et?',
    revokeBody: 'Sertifika hemen doğrulanamaz hâle gelir. Kazanılan puanlar geri alınmaz.',
    revokeReason: 'Gerekçe',
    revoked: 'Sertifika iptal edildi.',
    certificateOfCompletion: 'Tamamlama Sertifikası',
    hasCompleted: 'başarıyla tamamladı',
    certificateEyebrow: 'Sertifika',
    certifiesThat: 'Bu belge ile onaylanır ki',
    hasCompletedProgram: 'aşağıdaki eğitimi başarıyla tamamlamıştır',
    validUntil: '{date} tarihine kadar geçerli',
    verifyAt: 'Bu sertifikayı doğrula:',
    preview: 'Sertifikayı önizle',
  },

  admin: {
    coursesTitle: 'Kurslar',
    coursesSubtitle: 'Kurs içeriği oluştur ve yönet.',
    newCourse: 'Yeni kurs',
    editCourse: 'Kursu düzenle',
    courseCreated: 'Kurs oluşturuldu.',
    courseUpdated: 'Kurs kaydedildi.',
    courseDeleted: 'Kurs silindi.',
    coursePublished: 'Kurs yayınlandı.',
    courseUnpublished: 'Kurs taslağa alındı.',
    courseArchived: 'Kurs arşivlendi.',
    deleteCourseTitle: 'Bu kursu sil?',
    deleteCourseBody: 'Bu işlem geri alınamaz. Öğrenciler kullandıysa silmek yerine arşivle.',
    tabDetails: 'Detaylar',
    tabContent: 'İçerik',
    tabQuiz: 'Sınav',
    tabCompletion: 'Tamamlama',
    tabPublish: 'Yayınlama',
    slug: 'URL Kısaltması',
    slugHint: 'Kurs adresinde kullanılır. Başlıktan üretilir.',
    shortDescription: 'Kısa Açıklama',
    shortDescriptionHint: 'Kurs kartlarında görünen tek satır.',
    documentEditorHint:
      'Kursu belge gibi yaz: başlıklar, listeler, görseller, YouTube ve HTTPS iframe. Öğrenciler görmeden önce içerik temizlenir.',
    documentEditorPlaceholder: 'Kursu anlat, örnek ekle, bir walkthrough göm…',
    insertLink: 'Bağlantı',
    insertImage: 'Görsel',
    insertYoutube: 'YouTube',
    insertIframe: 'Iframe',
    insertImagePrompt: 'Görsel adresi (https://)',
    insertYoutubePrompt: 'YouTube adresi',
    insertIframePrompt: 'Gömülecek adres (https:// iframe src)',
    thumbnail: 'Kapak Görseli',
    thumbnailHint: 'Kurs ve yolculuk kartlarında görünür. Academy kapaklarından birini seç.',
    thumbnailLibrary: 'Kapak görseli seç',
    chooseThumbnail: 'Kapak seç',
    clearThumbnail: 'Kapağı kaldır',
    durationFromLessons: 'Bu kurstaki ders dakikalarının toplamıdır.',
    durationFromCourses: 'Bu yolculuktaki kurs sürelerinin toplamıdır.',
    courseIllustration: 'Kurs illüstrasyonu',
    courseIllustrationHint: 'Bu görsel, kursun katalogdaki kimliğidir.',
    courseIllustrationLibrary: 'Kurs görseli seç',
    chooseIllustration: 'Görsel seç',
    illustrationCovers: 'Kapaklar',
    illustrationModules: 'Ürün görselleri',
    illustrationDrawings: 'İllüstrasyonlar',
    illustrationPhotos: 'Fotoğraflar',
    illustrations: {
      moduleAdministration: 'Yönetim',
      moduleAllgemein: 'Genel',
      moduleArtikelPim: 'Ürün / PIM',
      moduleCrm: 'CRM',
      moduleCrmPhoto: 'CRM',
      moduleEcommerce: 'E-Ticaret',
      moduleEinkauf: 'Satın Alma',
      moduleEntwicklung: 'Geliştirme',
      moduleFinanzen: 'Finans',
      moduleKassePos: 'Kasa / POS',
      moduleMobileLager: 'Mobil Depo Uygulaması',
      moduleVerkauf: 'Satış',
      moduleVersand: 'Sevkiyat',
      erp: 'ERP / Kurumsal',
      cloud: 'Bulut ERP',
      dashboard: 'İş Paneli',
      sales: 'Satış Yönetimi',
      purchasing: 'Satın Alma',
      warehouse: 'Depo',
      inventory: 'Stok',
      products: 'Ürünler',
      crm: 'CRM',
      production: 'Üretim',
      supplyChain: 'Tedarik Zinciri',
      finance: 'Finans',
      invoice: 'Fatura',
      documents: 'Belgeler',
      workflow: 'İş Akışı',
      automation: 'Otomasyon',
      ai: 'Yapay Zeka',
      integration: 'Entegrasyon',
      users: 'Kullanıcılar ve Roller',
      analytics: 'Analiz',
      photoOperations: 'İş operasyonları',
      photoCloud: 'Veri merkezi',
      photoWarehouse: 'Depo',
      photoFulfillment: 'Sipariş hazırlama',
      photoFinance: 'Finans verisi',
      photoLogistics: 'Lojistik',
      photoTeam: 'Ekip',
      photoAnalytics: 'Analiz ekranı',
      photoServers: 'Sunucular',
      photoFactory: 'Üretim',
    },
    cover: 'Kapak görseli',
    tags: 'Etiketler',
    tagsHint: 'Etiket eklemek için Enter tuşuna bas.',
    objectives: 'Öğrenme Hedefleri',
    prerequisites: 'Ön Koşullar',
    estimatedDuration: 'Tahmini Süre (Dakika)',
    visibility: 'Görünürlük',
    visibilityHint:
      'Yayınlanmış ve grup atanmamış herkese açık içerik: bağlantısı olan giriş yapmadan görüntüleyebilir (sınav ve ilerleme kayıtlı değildir). Gruplar kaydı sınırlar. Grup seçildiğinde, yayınlanmış ve herkese açık içerik yalnızca seçili gruplardan en az birine ait kullanıcıların kataloğunda görünür.',
    groups: 'Gruplar',
    courseGroupsLabel: 'Gruplar (Kimler Kaydolabilir)',
    courseGroupsHint:
      'Grup seçildiğinde, bağlantıyla paylaşılan özel kurslar dahil, seçili gruplardan en az birine ait kullanıcılar kursu görüntüleyebilir ve kaydolabilir. Grup seçilmezse herkese açık kurslara kayıt serbesttir; özel kurslarda atama gerekir. Atanan Öğrenenler listesine eklenen kullanıcılar, grup üyeliklerinden bağımsız olarak kursa kaydedilir.',
    groupsHint:
      'Herkese açık içerikte boş bırakırsanız link herkese açıktır. Özel içerikte boş bırakmak yalnızca personel ve atama demektir. Grup seçmek erişimi o öğrenen tiplerine kısıtlar.',
    publicLinkHint:
      'Bu salt görüntüleme bağlantısını paylaşın. Sınav ve ilerleme için giriş gerekir.',
    guestPreview: 'Önizleme görüntülüyorsunuz. Sınav ve ilerleme için giriş yapın.',
    guestPreviewAuthed: 'Önizleme görüntülüyorsunuz. Sınav ve ilerleme için kursa kaydolun.',
    guestQuizLocked: 'Sınav için hesap gerekir. Başlamak için giriş yapın.',
    guestQuizEnroll: 'Bu sınava girmek ve ilerlemenizi kaydetmek için kursa kaydolun.',
    openAsLearner: 'Hesabımda aç',
    sections: 'Bölümler',
    addSection: 'Bölüm ekle',
    sectionTitle: 'Bölüm başlığı',
    noSections: 'Henüz bölüm yok. Kursu kurmaya başlamak için bir tane ekle.',
    addLesson: 'Ders ekle',
    lessonType: 'Ders Türü',
    lessonTypeVideo: 'Video',
    lessonTypeText: 'Metin',
    lessonTypeQuiz: 'Sınav',
    noLessons: 'Bu bölümde henüz ders yok.',
    lessonRequired: 'Tamamlama için Zorunlu',
    lessonSaved: 'Ders kaydedildi.',
    lessonDeleted: 'Ders silindi.',
    lessonArchived: 'Ders arşivlendi.',
    lessonArchivedHint:
      'Öğrencilerin bu dersteki ilerlemesi olduğu için silinmedi, arşivlendi. Artık tamamlama için sayılmaz.',
    deleteLessonTitle: 'Bu dersi sil?',
    deleteLessonBody: 'Bu dersteki öğrenci ilerlemesi korunur ancak ders gizlenir.',
    deleteSectionBody: 'Bu bölümdeki dersler gruptan çıkar. Silinmezler.',
    ungroupedLessons: 'Grupsuz dersler',
    questionTypeSingle: 'Tek seçim',
    questionTypeMultiple: 'Çoklu seçim',
    questionTypeTrueFalse: 'Doğru / Yanlış',
    settingsSaved: 'Ayarlar kaydedildi.',
    defaultPoints: 'Yeni Kurs için Varsayılan Puan',
    assignTitle: 'Öğrencilere ata',
    assignSubtitle: 'Seçilen öğrenciler hemen kaydolur ve bitiş tarihini panolarında görür.',
    tabAssignments: 'Atamalar',
    designTitle: 'Arayüz bileşenleri',
    reorderSaved: 'Sıralama kaydedildi.',
    moveUp: 'Yukarı taşı',
    moveDown: 'Aşağı taşı',
    dragLesson: 'Taşımak için sürükle',
    dragJourneyCourse: 'Sıralamak için sürükle',
    dropLessonHere: 'Dersi buraya bırak',
    videoMetadata: 'Video',
    videoTitle: 'Video Başlığı',
    videoUrl: 'Harici Video Adresi',
    videoUrlHint:
      'YouTube, Guidde veya başka bir HTTPS gömme bağlantısı, ya da doğrudan video dosyası yapıştır. Buraya dosya yüklenmez.',
    videoPath: 'Harici Dosya Yolu',
    videoDuration: 'Süre (Saniye)',
    videoThumbnail: 'Küçük Görsel Adresi',
    videoTranscript: 'Transkript',
    videoTranscriptHint:
      'İsteğe bağlı. .txt, .vtt veya .srt dosyası yükleyin. Öğrenciler videonun altında görür.',
    uploadTranscript: 'Transkript yükle',
    transcriptWrite: 'veya buradan yazın',
    transcriptPlaceholder: 'Transkripti buraya yapıştırın veya yazın',
    replaceTranscript: 'Transkripti değiştir',
    transcriptAttached: 'Mevcut transkript ({count} karakter)',
    transcriptEmpty: 'Bu dosyada metin yok.',
    videoStatus: 'Video durumu',
    uploadVideo: 'Video yükle',
    uploadVideoHint:
      'Harici dosya sunucusuna yükleme henüz bağlı değil. Dosya seçmek bilgilerini kaydeder ve isteği günlüğe yazar.',
    selectedFile: 'Seçilen dosya',
    uploadRequested: 'Yükleme istendi. İstek, dosya sunucusu entegrasyonu için günlüğe yazıldı.',
    textContent: 'Ders İçeriği',
    textContentHint: 'Temel biçimlendirme desteklenir. İçerik gösterilmeden önce temizlenir.',
    resources: 'İndirilenler',
    addResource: 'İndirilecek dosya ekle',
    completionTitle: 'Tamamlama koşulları',
    completionSubtitle: 'Kursun tamamlanmış sayılması için öğrencinin yapması gerekenler.',
    requiredLessons: 'Zorunlu dersler',
    requiredLessonsCount: '{total} dersten {count} tanesi zorunlu',
    requiresQuiz: 'Geçilmesi Gereken bir Sınav Olsun',
    requiresQuizHint: 'Kapalıysa zorunlu dersleri bitirmek kursu tamamlar.',
    finalQuiz: 'Final sınavı',
    passingScore: 'Geçme Puanı (%)',
    coursePoints: 'Verilen Puan',
    certificateEnabled: 'Sertifika Ver',
    videoCompletePercent: 'Video Şu Oranda İzlenmiş Sayılır (%)',
    publishTitle: 'Yayınlama',
    publishSubtitle: 'Öğrenciler kursu görmeden önce geçmesi gereken kontroller.',
    publishCheckLessons: 'En az bir zorunlu ders',
    publishCheckQuiz: 'En az bir soru içeren bir final sınavı',
    publishCheckDescription: 'Kısa bir açıklama',
    publishBlocked: 'Yayınlamadan önce yukarıdaki maddeleri tamamla.',
    quizBuilderTitle: 'Sınav',
    quizBuilderSubtitle: 'Öğrenciler bunu kursun son maddesi olarak görür.',
    createQuiz: 'Sınav oluştur',
    quizTitle: 'Sınav Başlığı',
    timeLimitMinutes: 'Süre Sınırı (Dakika)',
    timeLimitHint: 'Sınır olmaması için boş bırak.',
    maxAttempts: 'En Fazla Deneme',
    maxAttemptsHint: 'Sınırsız deneme için boş bırak.',
    shuffleQuestions: 'Soruları Karıştır',
    addQuestion: 'Soru ekle',
    importQuestions: 'Soru içe aktar',
    importPoints: 'Soru başına puan',
    importPointsInvalid: '1 ile 100 arasında bir tam sayı girin.',
    importQuestionsHint:
      'Tek seçimli soruları yapıştırın. AIKEN (A. B. C. ve sonra ANSWER: B) ya da her şık kendi satırında, doğru şık ✓ ile işaretli olsun. Soruların arasına boş satır koyun.',
    importQuestionsPlaceholder: 'Soruları AIKEN veya ✓ biçiminde yapıştırın',
    importQuestionsAction: 'İçe aktar',
    importQuestionsSuccess: '{count} soru içe aktarıldı.',
    importQuestionsEmpty: 'En az bir soru yapıştırın.',
    importQuestionsError: 'Soru {question}: {reason}',
    aikenUnrecognized: 'Bu blok AIKEN ya da ✓ biçiminde değil.',
    aikenNoAnswer: 'ANSWER: X ekleyin veya tam olarak bir şıkkı ✓ ile işaretleyin.',
    aikenAnswerMismatch: 'ANSWER {answer} hiçbir şıkla eşleşmiyor.',
    aikenTooFewOptions: 'En az iki şık gerekli.',
    aikenMultipleCorrect: 'Yalnızca bir doğru cevap olabilir.',
    aikenDuplicateLetter: '{letter} harfi birden fazla kullanılmış.',
    aikenNoPrompt: 'Soru metni eksik.',
    aikenAmbiguous: 'Ya ANSWER: X kullanın ya da ✓ işareti; ikisini birden değil.',
    aikenTooLong: 'Soru veya bir şık çok uzun.',
    questionPrompt: 'Soru',
    questionType: 'Tür',
    questionPoints: 'Puan',
    questionExplanation: 'Gönderimden Sonra Gösterilecek Açıklama',
    addOption: 'Seçenek ekle',
    optionLabel: 'Doğru cevap',
    markCorrect: 'Doğru',
    noQuestions: 'Henüz soru yok.',
    quizSaved: 'Sınav kaydedildi.',
    quizNeedsCorrectOption: 'Her sorunun en az bir doğru cevabı olmalı.',
    quizEditWarning:
      'Bu sınava girilmiş. Yapısal değişiklikler açık denemeleri iptal eder; gönderilmiş denemeler puanlarını korur.',
    journeysTitle: 'Öğrenme Yolculukları',
    journeysSubtitle: 'Kursları yapılandırılmış bir yolculukta birleştir.',
    newJourney: 'Yeni yolculuk',
    editJourney: 'Yolculuğu düzenle',
    journeySaved: 'Yolculuk kaydedildi.',
    journeyMode: 'Tamamlama Sırası',
    journeyCourses: 'Kurslar',
    filterByJourney: 'Öğrenme Yolculuğu',
    allJourneys: 'Tüm yolculuklar',
    filterContainsCourse: 'İçerdiği kurs',
    allCourses: 'Tüm kurslar',
    backToJourney: 'Yolculuğa dön',
    backToCourses: 'Kurslara dön',
    addCourseToJourney: 'Kurs ekle',
    addExistingCourse: 'Mevcut kurs',
    addExistingCourseHint: 'Katalogda zaten olan bir kursu seç.',
    createCourseForJourney: 'Yeni kurs',
    createCourseForJourneyHint:
      'Başlıkla bir taslak oluşturur ve bu yolculuğa hemen ekler. Dersleri kurs düzenleyicide eklersin.',
    createAndAddToJourney: 'Oluştur ve ekle',
    noCatalogCoursesLeft: 'Eklenebilecek tüm kurslar zaten bu yolculukta.',
    courseAddedToJourney: 'Kurs yolculuğa eklendi.',
    courseRequired: 'Zorunlu',
    courseOptional: 'İsteğe bağlı',
    noJourneyCourses: 'Henüz kurs eklenmedi.',
    settingsTitle: 'Ayarlar',
    settingsSubtitle: 'Yeni içeriklere uygulanan varsayılanlar.',
    defaultsSection: 'İçerik varsayılanları',
    maintenanceSection: 'Bakım',
    recalcStates: 'Kurs durumlarını yeniden hesapla',
    recalcStatesHint:
      'Her kaydı ders ilerlemesi ve sınav denemelerinden yeniden hesaplar. Her zaman güvenle çalıştırılabilir.',
    recalcDone: '{count} kayıt yeniden hesaplandı.',
    brandingSection: 'Marka',
    organisationName: 'Kurum Adı',
    defaultLocale: 'Varsayılan Dil',
  },

  users: {
    title: 'Kullanıcılar',
    subtitle: 'Platforma kimin erişeceğini ve neler yapabileceğini yönet.',
    invite: 'Kullanıcı davet et',
    inviteTitle: 'Kullanıcı davet et',
    inviteSubtitle: 'Şifresini belirlemesi için bağlantı içeren bir e-posta alır.',
    inviteSent: '{email} adresine davet gönderildi.',
    inviteFailed: 'Davet gönderilemedi.',
    pendingInvitations: 'Bekleyen davetler',
    revokeInvitation: 'İptal et',
    invitationRevoked: 'Davet iptal edildi.',
    role: 'Rol',
    roleName: {
      learner: 'Öğrenen',
      instructor: 'Eğitmen',
      admin: 'Yönetici',
    },
    roleChanged: 'Rol güncellendi. Kullanıcı değişikliği bir sonraki girişinde görür.',
    active: 'Aktif',
    inactive: 'Devre dışı',
    activate: 'Aktifleştir',
    deactivate: 'Devre dışı bırak',
    activated: 'Kullanıcı aktifleştirildi.',
    deactivated: 'Kullanıcı devre dışı bırakıldı.',
    joined: 'Katıldı',
    lastActive: 'Son etkinlik',
    viewProgress: 'İlerlemeyi görüntüle',
    progressTitle: '{name} için ilerleme',
    assignCourse: 'Kurs ata',
    assignedLearners: 'Atanan Öğrenciler',
    assignmentsSaved: 'Atamalar kaydedildi.',
    assignJourney: 'Yolculuk ata',
    assigned: '{count} öğrenciye atandı.',
    unassign: 'Atamayı kaldır',
    unassigned: 'Atama kaldırıldı.',
    dueDate: 'Son Tarih',
    selectLearners: 'Öğrenciler',
    noLearnersSelected: 'En az bir öğrenci seç.',
    empty: 'Filtrelerinle eşleşen kullanıcı yok.',
    cannotChangeOwnRole: 'Kendi rolünü değiştiremezsin.',
    cannotDeactivateSelf: 'Kendi hesabını devre dışı bırakamazsın.',
    groups: 'Gruplar',
    groupsUpdated: 'Gruplar güncellendi.',
  },

  groups: {
    label: 'Gruplar',
    partner: 'Partner',
    developer: 'Geliştirici',
    viewer: 'İzleyici',
  },

  reports: {
    title: 'Raporlar',
    subtitle: 'Kayıt, tamamlama ve sınav performansı.',
    tabCourses: 'Kurslar',
    tabLearners: 'Öğrenciler',
    tabQuizzes: 'Sınavlar',
    tabJourneys: 'Öğrenme Yolculukları',
    course: 'Kurs',
    enrollments: 'Kayıtlar',
    completed: 'Tamamlanan',
    inProgress: 'Devam eden',
    notStarted: 'Başlanmayan',
    completionRate: 'Tamamlama oranı',
    averageProgress: 'Ortalama ilerleme',
    quiz: 'Sınav',
    attempts: 'Denemeler',
    learners: 'Öğrenciler',
    passRate: 'Geçme oranı',
    averageScore: 'Ortalama puan',
    passingScore: 'Geçme puanı',
    learnerName: 'Öğrenci',
    coursesCompleted: 'Tamamlanan kurslar',
    points: 'Puan',
    certificates: 'Sertifikalar',
    exportCsv: 'CSV olarak indir',
    empty: 'Bu rapor için henüz veri yok.',
  },

  states: {
    loading: 'Yükleniyor',
    loadingHint: 'Bir saniye…',
    errorTitle: 'Bir şeyler ters gitti',
    errorHint: 'İstek tamamlanamadı. Tekrar deneyebilirsin.',
    emptyTitle: 'Burada henüz bir şey yok',
    notFoundTitle: 'Sayfa bulunamadı',
    notFoundHint: 'Aradığın sayfa yok ya da taşınmış.',
    forbiddenTitle: 'Erişim yok',
    forbiddenHint: 'Bu sayfayı görüntüleme izniniz yok.',
    goHome: 'Panele git',
    offlineTitle: 'Bağlantın yok',
    offlineHint: 'Bağlantını kontrol et. Çalışmaların geri gelene kadar yerel olarak saklanır.',
  },

  errors: {
    generic: 'Bir şeyler ters gitti. Lütfen tekrar dene.',
    network: 'Sunucuya ulaşamadık. Bağlantını kontrol et.',
    unauthorized: 'Bunu yapmak için giriş yapmalısın.',
    forbidden: 'Bunu yapma izniniz yok.',
    notFound: 'Aradığını bulamadık.',
    conflict: 'Bu zaten var.',
    invalidCredentials: 'Bu e-posta ve şifre birleşimi doğru değil.',
    invalidReybexCredentials: 'Bu Reybex kullanıcı adı ve şifre birleşimi doğru değil.',
    reybexEmailInUse: 'Bu e-posta LMS hesabında zaten kayıtlı. LMS hesabı seçeneğiyle giriş yap.',
    reybexNotConfigured: 'Reybex ile giriş yapılandırılmamış.',
    reybexUnavailable: 'Reybex’e ulaşılamadı. Biraz sonra tekrar dene.',
    reybexTenantNotAllowed: 'Bu Reybex hesabının buradan giriş izni yok.',
    passwordManagedByReybex: 'Bu şifre Reybex üzerinden yönetilir.',
    emailInUse: 'Bu e-posta ile bir hesap zaten var.',
    weakPassword: 'Daha uzun bir şifre seç.',
    rateLimited: 'Çok fazla deneme. Lütfen biraz bekleyip tekrar dene.',
    slugTaken: 'Bu URL kısaltması başka bir kurs tarafından kullanılıyor.',
    notEnrolled: 'Bu kursa kayıtlı değilsin.',
    lessonsIncomplete: 'Önce zorunlu dersleri tamamla.',
    maxAttempts: 'Bu sınav için tüm denemelerini kullandın.',
    quizNoQuestions: 'Bu sınavda henüz soru yok.',
    attemptClosed: 'Bu deneme zaten gönderildi.',
    selfEnrollClosed: 'Bu kurs kendi kendine kayda açık değil.',
    lessonHasProgress:
      'Öğrencilerin bu derste ilerlemesi var; bu yüzden ders yalnızca arşivlenebilir, silinemez.',
    schemaMissing:
      'Veritabanı şeması henüz uygulanmadı. Proje klasöründe şunu çalıştır: npm run db:migrate',
  },

  validation: {
    required: 'Bu alan zorunlu',
    email: 'Geçerli bir e-posta adresi gir',
    minLength: 'En az {min} karakter kullan',
    maxLength: 'En fazla {max} karakter kullan',
    passwordMin: 'En az 8 karakter kullan',
    passwordMatch: 'Şifreler birbiriyle eşleşmiyor',
    passwordNeeds: 'Hâlâ gerekli: {items}.',
    passwordNeed: {
      length: 'En az 9 karakter',
      upper: 'Bir büyük harf ekle',
      lower: 'Bir küçük harf ekle',
      digit: 'Bir rakam ekle',
      special: 'Bir özel karakter ekle',
    },
    number: 'Bir sayı gir',
    min: 'En az {min} olmalı',
    max: 'En fazla {max} olmalı',
    url: 'Geçerli bir adres gir',
    slug: 'Yalnızca küçük harf, sayı ve tire kullan',
    fileTooLarge: 'Bu dosya {max} sınırından büyük',
    fileType: 'Bu dosya türü desteklenmiyor',
    atLeastOne: 'En az bir tane seç',
    atLeastOneCorrect: 'En az bir seçeneği doğru olarak işaretle',
    atLeastTwoOptions: 'En az iki cevap seçeneği ekle',
    positiveInteger: 'Sıfırdan büyük bir tam sayı gir',
  },

  rewards: {
    continue: 'Devam et',
    kindLesson: 'Ders tamam',
    kindQuiz: 'Sınav geçildi',
    kindCourse: 'Kurs tamam',
    kindCertificate: 'Sertifika kazandın',
    kindJourney: 'Öğrenme Yolculuğu tamam',
    lessonTitle: 'Güzel iş',
    lessonBody: '“{title}” dersini bitirdin.',
    quizTitle: 'Geçtin',
    quizBody: 'Bu skor sonraki adımı açar.',
    quizBodyCertificate: 'Geçme puanına ulaştın — sertifikan hazır.',
    quizRetryHint: 'Kutlama yok — dersi gözden geçir ve tekrar dene.',
    courseTitle: 'Kurs tamamlandı',
    courseBody: '{title} kursunu bitirdin.',
    certificateTitle: 'Sertifika hazır',
    certificateBody: '{title} için sertifika kazandın.',
    viewCertificate: 'Sertifikayı gör',
    journeyTitle: 'Yolculuk tamamlandı',
    journeyBody: '“{title}” yolculuğunu bitirdin.',
    score: 'Puan: {score}',
  },

  setup: {
    title: 'Yönetici kurulumu',
    subtitle: 'İlk yönetici kurum için kursları tanımlayabilir.',
    body: 'Henüz yönetici yok. Bu rolü alırsan kurs oluşturup yayınlayabilirsin. Sonraki kayıtlar, davet etmediğin sürece öğrenci kalır.',
    claim: 'Yönetici ol',
    claimed: 'Artık yöneticisin.',
    alreadyAdmin: 'Zaten yönetici erişimin var. Kurs tanımlamak için yönetim panosunu aç.',
    unavailable: 'Bir yönetici zaten var. Erişim gerekiyorsa ondan davet iste.',
  },

  landing: {
    metaTitle: 'Reybex Academy',
    product: 'Academy',
    navJourneys: 'Yolculuklar',
    navHow: 'Nasıl çalışır',
    navCerts: 'Sertifikalar',
    navAudience: 'Kime',
    themeToLight: 'Açık moda geç',
    themeToDark: 'Koyu moda geç',
    signIn: 'Giriş yap',
    signUp: 'Hesap oluştur',
    openCampus: 'Campus’u aç',
    eyebrow: 'Reybex Cloud ERP öğrenme platformu',
    headlineLead: 'İşi yürüten',
    headlineAccent: 'ERP’yi öğren.',
    sub: 'Partner, geliştirici ve kullanıcılar için yapılandırılmış öğrenme yolları — depodan finansa. Dersleri bitir, sınavı geç, herkesin doğrulayabileceği bir sertifika kazan.',
    ctaStart: 'Öğrenmeye başla',
    ctaExplore: 'Yolculuklara bak',
    statLevels: 'Seviyeler',
    statLevelsValue: 'L0–L4',
    statAudiences: 'Hedef kitle',
    statAudiencesValue: '3 rol',
    statLangs: 'Diller',
    statLangsValue: 'DE · EN · TR',
    statProof: 'Kanıt',
    statProofValue: 'Sertifika',
    audiencesTitle: 'Reybex’i kullanan insanlar için',
    audiencesSub:
      'Partner, Developer ve Viewer — her biri Cloud ERP’deki gerçek işine uygun bir yol alır. Genel bir katalog değil.',
    audiencePartnerTitle: 'Partner',
    audiencePartnerBody:
      'Uygulama ortakları için enablement: süreçler, konfigürasyon ve müşteri ekibinin nasıl eğitileceği.',
    audienceDeveloperTitle: 'Developer',
    audienceDeveloperBody:
      'Konfigürasyon derinliği, API’ler ve kurulumdan genişletmeye teknik yol — son kullanıcı eğitiminden ayrı.',
    audienceViewerTitle: 'Viewer',
    audienceViewerBody:
      'Satış, depo, satın alma ve finansta günlük iş. Rolün ilerlemesi için gereken kadar.',
    levelsEyebrow: 'Müfredat',
    levelsTitle: 'İlk girişten sertifikaya bir yol',
    levelsSub:
      'Beş seviye, reybex organizasyonuyla aynı dil. Bir kurs, sınav geçilmeden tamamlanmış sayılmaz.',
    level0: 'Temel',
    level0Body: 'Cloud ERP’de yön. Navigasyon, ana veriler, ortak çekirdek.',
    level1: 'Departman',
    level1Body: 'Satış, depo, satın alma, finans — uzmanın işi.',
    level2: 'Konfigürasyon',
    level2Body: 'Sistemin gerçek bir şirket için nasıl kurulduğu.',
    level3: 'Developer',
    level3Body: 'Entegrasyonlar, API-first ve reybex’i genişletmek.',
    level4: 'Uygulama ve sertifika',
    level4Body: 'Uygula, sınavı geç, sertifikayı al.',
    howTitle: 'Önce sınav. Sonra sertifika.',
    howSub:
      'Bir kurs ancak zorunlu dersler bitince ve sınav geçilince tamamlanır. Puan ve sertifika otomatik gelir — elle işaretlenmez.',
    how1Title: 'Yolculuk seç',
    how1Body: 'Sıralı yollar bir kurs bitince sonrakini açar. Esnek yollarda sıra sana kalır.',
    how2Title: 'Oynatıcıda öğren',
    how2Body: 'Video ve metin dersleri. İlerleme kaydedilir. Zorunlu içerikler bitirilmelidir.',
    how3Title: 'Sınavı geç',
    how3Body:
      'Puanlama sunucuda. Süre ve deneme limiti uygulanır. Doğru cevaplar gönderilene kadar gizlidir.',
    how4Title: 'Sertifikayı al',
    how4Body: 'Benzersiz numara, herkese açık doğrulama bağlantısı ve paylaşılabilir PDF.',
    journeysTitle: 'Öğrenme yolculukları',
    journeysSub: 'reybex modüllerinde role göre yollar — satış, depo, üretim, finans ve fazlası.',
    journeysCta: 'Tüm yolculuklar',
    featuresTitle: 'Bir akademinin ihtiyaç duyduğu her şey. Fazlası yok.',
    featureJourneysTitle: 'Yolculuklar',
    featureJourneysBody:
      'Sıralı veya esnek. Zorunlu kurslar. İlerleme her zaman gerçeklerden yeniden hesaplanır.',
    featureQuizTitle: 'Dürüst sınavlar',
    featureQuizBody: 'Sunucu tarafı puanlama. Oynatıcıya doğru cevap sızmaz.',
    featureCertsTitle: 'Doğrulanabilir sertifikalar',
    featureCertsBody:
      'Herkes genel doğrulama sayfasını açabilir. Yetki PDF’de değil, kayıtta durur.',
    featureGroupsTitle: 'Partner · Developer · Viewer',
    featureGroupsBody: 'İçerik, görmesi gereken gruba göre kapsamlanır.',
    featureReportsTitle: 'Yöneticiler için raporlar',
    featureReportsBody: 'Tamamlamalar, sınav geçme oranı, geciken atamalar — tek bakışta.',
    featureI18nTitle: 'Almanca, İngilizce, Türkçe',
    featureI18nBody: 'Akademi, reybex pazarının dillerini konuşur.',
    ctaTitle: 'Sıradaki modüle hazır mısın?',
    ctaBody: 'Hesap oluştur veya giriş yap. Yolun, sınavın, sertifikan.',
    footerTagline: 'reybex Cloud ERP için öğrenme kampüsü.',
    footerCourses: 'Kurslar',
    footerJourneys: 'Yolculuklar',
    footerVerify: 'Sertifikalar',
    footerRights: '© {year} EDIT Systems GmbH. Reybex Academy.',
    orbitSales: 'Satış',
    orbitWarehouse: 'Depo',
    orbitProduction: 'Üretim',
    orbitFinance: 'Finans',
    orbitCrm: 'CRM',
    orbitShop: 'Ticaret',
    menuOpen: 'Menüyü aç',
    menuClose: 'Menüyü kapat',
    mockChrome: 'Reybex Academy · Kurs oynatıcı',
    mockPath: 'Bu kurs',
    mockLesson1: 'Çalışma alanını tanı',
    mockLesson2: 'Temiz kalması gereken ana veriler',
    mockLesson3: 'Uçtan uca bir satış siparişi',
    mockQuiz: 'Final sınavı',
    mockNow: 'Uçtan uca bir satış siparişi',
    mockNowMeta: 'Video · zorunlu · 12 dk',
    mockRequired: 'Zorunlu',
    mockCertEyebrow: 'Sertifika',
    mockCertBody: 'Sınav geçilince düzenlenir. Herkese açık doğrulanır.',
  },

  categories: {
    'track-administration': 'Yönetim',
    'track-artikel-pim': 'Ürün ve PIM',
    'track-crm': 'CRM',
    'track-allgemein': 'Genel',
    'track-continuous': 'Sürekli',
    'track-e-commerce': 'E-Ticaret',
    'track-edi': 'EDI',
    'track-einkauf': 'Satın Alma',
    'track-entwicklung': 'Geliştirme',
    'track-finanzen': 'Finans',
    'track-hr': 'İnsan Kaynakları',
    'track-kasse-pos': 'Kasa / POS',
    'track-lager': 'Depo',
    'track-mobile-lager-app': 'Mobil Depo Uygulaması',
    'track-partner-enablement': 'Partner Eğitimi',
    'track-praxis': 'Uygulama',
    'track-produktion': 'Üretim',
    'track-projekte-service': 'Projeler ve Servis',
    'track-qualit-t': 'Kalite',
    'track-verkauf': 'Satış',
    'track-versand': 'Sevkiyat',
    'track-zertifizierung': 'Sertifikasyon',
    'ornek-depo-lojistik': 'Depo ve lojistik',
    'ornek-satis-faturalama': 'Satış ve faturalama',
  },
}
